import { useTranslations } from 'use-intl';
import toast from '@/components/atoms/toaster/helpers/toast';

type Translate = ReturnType<typeof useTranslations>;

interface AddToPurchaseListWithFeedbackArgs {
  /** The purchase-list add mutator from `usePurchaseLists`. */
  addToWishlists: (args: { wishlistIds: string[]; sku: string; count: number }) => Promise<{ success: boolean }>;
  translate: Translate;
  sku: string;
  wishlistIds: string[];
}

// EWM-188: add a product to the selected purchase lists at quantity 0
// (zero-default per Workshop 6) and show the matching confirmation toast.
//
// `addToWishlists` swallows BFF errors — it resolves to `{ success: false }`
// rather than throwing (see `usePurchaseLists`). So a success toast must be
// gated on the result: a failed add (e.g. a legitimate BFF 400) shows the
// generic error toast instead, mirroring `handleAddToCart`. Extracted from
// the view-model so this success/failure branching is unit-testable.
export const addToPurchaseListWithFeedback = async ({
  addToWishlists,
  translate,
  sku,
  wishlistIds,
}: AddToPurchaseListWithFeedbackArgs): Promise<boolean> => {
  const res = await addToWishlists({ wishlistIds, sku, count: 0 });

  if (!res.success) {
    toast.error(translate('common.something-went-wrong'));
    return false;
  }

  toast.success(translate('wishlist.added-to-list'));
  return true;
};
